// import axios from "axios";
// import jwt_decode from "jwt-decode";

// const axiosInstance = axios.create({
//   baseURL: "http://localhost:5000/api", // Change this to your actual backend API base URL
// });


// const refreshToken = async () => {
//     try {
//       const refreshToken = localStorage.getItem("refreshToken");
//       const response = await axios.post("/auth/refresh", { token: refreshToken });
//       localStorage.setItem("token", response.data.token);
//       return response.data.accessToken;
//     } catch (error) {
//       console.error("Failed to refresh token", error);
//       throw error;
//     }
//   };

//   // Request interceptor
// axiosInstance.interceptors.request.use(
//     (config) => {
//       const accessToken = localStorage.getItem("token");
//       if (accessToken) {
//         config.headers.Authorization = `Bearer ${accessToken}`;
//       }
//       return config;
//     },
//     (error) => {
//       return Promise.reject(error);
//     }
//   );

// // Response interceptor
// axiosInstance.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//       const originalRequest = error.config;
  
//       if (error.response.status === 403 && !originalRequest._retry) {
//         originalRequest._retry = true;
//         try {
//           const newAccessToken = await refreshToken();
//           originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
//           return axiosInstance(originalRequest);
//         } catch (refreshError) {
//           console.error("Error refreshing token:", refreshError);
//           localStorage.removeItem("token");
//           localStorage.removeItem("refreshToken");
//           window.location.href = "/login"; 
//           return Promise.reject(refreshError);
//       }
//     }
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;
  

import axios from "axios";
import jwt_decode from "jwt-decode";

const axiosInstance = axios.create({
  baseURL: "https://gidanbu-backend.onrender.com/api", // Base URL for all requests
  // baseURL: "http://localhost:5000/api", 
});

// Function to refresh the access token
const refreshToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      throw new Error("No refresh token found");
    }

    // Use axiosInstance to ensure the base URL is included
    const response = await axiosInstance.post("/auth/refresh", { token: refreshToken });
    const newAccessToken = response.data.accessToken;

    // Update the token in localStorage
    localStorage.setItem("token", newAccessToken);
    return newAccessToken;
  } catch (error) {
    console.error("Failed to refresh token", error);
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    window.location.href = "/login"; // Redirect to login on failure
    throw error;
  }
};

// Request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Check if the error is due to an expired token (401 Unauthorized)
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; // Mark the request as retried

      try {
        const newAccessToken = await refreshToken();
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest); // Retry the original request with the new token
      } catch (refreshError) {
        console.error("Error refreshing token:", refreshError);
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login"; // Redirect to login on failure
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;